// Injects the Umami tracker, but only when a website id is actually configured.
//
// This is deliberately not a static <script> tag in index.html. A static tag
// requests /s.js unconditionally, and any host without the Cloudflare Pages
// Function in front of it — a local `serve -s build`, a preview deploy, a
// misconfigured ANALYTICS_ORIGIN — answers that with the SPA's index.html
// fallback. The browser then parses HTML as JavaScript and throws
// "Unexpected token '<'" on every single page load.
//
// Gating the injection here makes REACT_APP_UMAMI_WEBSITE_ID a real switch
// rather than a cosmetic one: no id, no request, no error.
export function loadTracker(websiteId: string | undefined, doc: Document = document): boolean {
  if (!websiteId) return false;
  if (doc.querySelector('script[data-website-id]')) return false;

  const el = doc.createElement('script');
  el.defer = true;
  el.src = '/s.js';
  el.setAttribute('data-website-id', websiteId);
  doc.head.appendChild(el);
  return true;
}
